import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type ModelAssignmentsFetchFailedAction = {
	type: 'MODEL_ASSIGNMENTS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): ModelAssignmentsFetchFailedAction => ({
	type: 'MODEL_ASSIGNMENTS_FETCH_FAILED',
	payload,
});
